import { addDays, compareAsc, getDay, isSameDay, parseISO, startOfDay } from 'date-fns'
import { DeliveryTypeEnum } from 'modules/deliveryInfo/types'
import { TDayOfWeek, TScheduleDay } from 'modules/terminal/types'

const COURIER_START_DATE_PROTECT_INTERVAL = 2

const DAYS_OF_WEEK: TDayOfWeek[] = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']

export interface IDepartureDateDisabledParams {
  courierSchedule: string[] | undefined
  date: Date
  departureTerminalId: string
  departureTerminalSchedule: TScheduleDay[] | undefined
  departureType: DeliveryTypeEnum | undefined
  now: Date
}

/**
 * Является ли день выходным на терминале согласно его режиму работы.
 * Если график не задан, день выходным не считается
 */
function isTerminalDayOff(date: Date, terminalSchedule: TScheduleDay[] | undefined): boolean {
  const allowedDays = terminalSchedule?.map(({ dayOfWeek }) => DAYS_OF_WEEK.findIndex((day) => day === dayOfWeek))
  const correctDate = getDay(date) ? getDay(date) - 1 : 6

  if (!allowedDays?.length) {
    return false
  }

  return !allowedDays.includes(correctDate)
}

/**
 * Недоступна ли дата забора груза для выбранного типа доставки.
 * Для курьера без расписания выездов ориентируемся на режим работы терминала
 * с защитным интервалом от текущей даты
 */
export function isDepartureDateDisabled({
  courierSchedule,
  date,
  departureTerminalId,
  departureTerminalSchedule,
  departureType,
  now
}: IDepartureDateDisabledParams): boolean {
  const day = startOfDay(date)
  const today = startOfDay(now)

  if (compareAsc(day, today) < 0) {
    return true
  }

  if (departureType === DeliveryTypeEnum.courier) {
    if (isSameDay(day, today)) {
      return true
    }

    if (courierSchedule?.length) {
      return !courierSchedule.some((courierScheduleDate) => isSameDay(day, startOfDay(parseISO(courierScheduleDate))))
    }

    if (compareAsc(day, addDays(today, COURIER_START_DATE_PROTECT_INTERVAL)) < 0) {
      return true
    }

    if (departureTerminalId) {
      return isTerminalDayOff(date, departureTerminalSchedule)
    }

    return false
  }

  if (departureType === DeliveryTypeEnum.terminal && departureTerminalId) {
    return isTerminalDayOff(date, departureTerminalSchedule)
  }

  return false
}
